import React, { useEffect, useState } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';

const SettingsPage = ({ uid, name }) => {
  const [participants, setParticipants] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const docRef = doc(db, "reservations", uid);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          const data = docSnap.data();
          if (data.participants) {
            setParticipants(data.participants);
          }
        }
      } catch (error) {
        console.error("Error fetching settings data:", error);
      } finally {
        setLoading(false);
      }
    };

    if (uid) {
      fetchUserData();
    }
  }, [uid]);

  if (loading) {
    return <div>Loading Settings...</div>;
  }

  return (
    <div className="text-white space-y-4">
      <h2 className="text-2xl font-bold mb-4">User Info & Participants</h2>

      {/* User Info */}
      <div className="bg-gray-700 p-4 rounded">
        <h3 className="text-xl font-semibold mb-2">User Information</h3>
        <p><strong>Name:</strong> {name}</p>
      </div>

      {/* Participants */}
      <div className="bg-gray-700 p-4 rounded">
        <h3 className="text-xl font-semibold mb-2">Participants</h3>
        {!participants || participants.length === 0 ? (
          <p>No participants found.</p>
        ) : (
          <ul className="list-disc ml-4">
            {participants.map((participant, index) => (
              <li key={index}>
                {participant.firstName} {participant.lastName} ({participant.email || "No Email"})
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default SettingsPage;
